/**
 * Holds state for the menu system
 */
export class Menu {
  /**
   * Whether or not the menu is open
   */
  public isOpen: boolean = false

  /** Helper function to close menu */
  public close(): void {
    this.isOpen = false
  }
  /** Helper function to open menu */
  public open(): void {
    this.isOpen = true
  }
}
